export const TICKET_CLASS_CATEGORY_ADMISSION = 'admission';
export const TICKET_CLASS_CATEGORY_ADDON = 'add_on';
export const TICKET_CLASS_CATEGORY_DONATION = 'donation';
